import requests from "./httpService";

const BookingServices = {

    getBooking : async () =>{
       
        return requests.get(`/booking/all-booking`);
    },

    gettodaybookingdate : async () =>{
       
        return requests.get(`/admin/today-booking-data`);
    },

    gettodaybookingPendingdata : async () =>{
       
        return requests.get(`/admin/today-booking-data-pending`);
    },

    gettodaybookingCompletedata: async () =>{
       
        return requests.get(`/admin/today-booking-data-complete`);
    },

    getPendingBooking : async () =>{
       
        return requests.post(`/booking/pendingssss`);
    },

    getCancelledBookings : async () =>{
       
        return requests.get(`/booking/cancel-booking`);
    },

    getOngoingBookings : async () =>{
       
        return requests.post(`/booking/ongoing`);
    },

    getPartnerAssignBookings : async () =>{
       
        return requests.get(`/booking/pending-booking`);
    },

    getPartnerStartServicesBookings : async () =>{

        return requests.post(`/booking/start-booking-services`);
    },

    getConfirmedBookings : async () =>{
       
        return requests.get(`/booking/confirm-booking`);
    },

    getOutOfDeliveryBookings : async () =>{

        return requests.post(`/booking/outofdelivery`);
    },

    getCompletedBookings : async () =>{
       
        return requests.get(`/booking/complete-booking`);
    },


    
    
    getUserBooking : async (userId) =>{
       
        return requests.get(`/booking/user/${userId}`);
    },
    updateBooking : async (id,body) =>{
    
        return requests.patch(`/booking/${id}`,body);
    },
    getBookingByID : async (id) =>{
     
        return requests.get(`/booking/${id}`);
    },

    createBooking  : async (body) =>{
        return requests.post(`/booking`,body);
    },
    assignVendor  : async (body) =>{
       
        return requests.post(`/booking/assign-vendor`,body);
    },

    deleteBooking  : async (id) =>{
        return requests.delete(`/booking/${id}`);
    }
 
 

}

export default BookingServices;